import React from 'react'
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";
import {useSelector} from "react-redux";
import {useFormContext} from "react-hook-form";
import classNames from "classnames";
import {useOnSubmit} from "../utils"
import FlaveButton from "./form_fields/raw_fields/flave_button";
import {pick} from "lodash";

const FormButtons = () => {
  const {handleSubmit, setError, clearErrors, getValues, formState: { errors }} = useFormContext()

  const declineMode = useSelector(state => state.decline_mode) || "disabled"

  const formFieldStyle = useSelector(state => state.form_field_style)
  const isMaterialUiPage = formFieldStyle.startsWith("material_ui")
  const inputWidth = useSelector(state => state.input_width) || "8"
  const labelWidth = useSelector(state => state.label_width) || "3"

  const submitButtonText = useSelector(state => state.submitButtonText)
  const submitButtonSendingText = useSelector(state => state.submitButtonSendingText)
  const declineButtonText = useSelector(state => state.decline_button_text)

  const isSending = useSelector(state => state.registrationPageState?.isSending)
  const isDeclining = useSelector(state => state.registrationPageState?.isDeclining)
  const sendingAccept = isSending && !isDeclining
  const sendingDecline = isSending && isDeclining

  const fields = Object.keys(useSelector(state => state.tag_owner.fields));

  const onSubmit = useOnSubmit(setError)

  const onSubmitAccept = handleSubmit(onSubmit)

  const onSubmitDecline = (e) => {
    clearErrors()

    const data = getValues()
    data.decline = {
      ...data.decline,
      status: "1"
    }
    onSubmit(data)
  }

  return <div className="form-group submit-button-container r-submit row">
    {!isMaterialUiPage && <div className={`r-label col-md-${labelWidth} col-form-label optional-label`}/>}
    <div className={`r-submit-container col-sm flex-wrap ${isMaterialUiPage ? "justify-content-center" : ""}`}>
      <div className={classNames("submit-div", {"sub-btn": declineMode && declineMode == "with_button"})}>
        <FlaveButton
          id="btnSubmit"
          onClick={onSubmitAccept}
          muiColor={"primary"}
          bootstrapVariant={"btn-success"}
          disabled={sendingAccept || sendingDecline}
          className={classNames("submit")}
        >
          <i
            className={classNames("submit-icon fa mr-2", {
              "fa-spinner fa-spin": sendingAccept,
              "submit-icon fa fa-check": !sendingAccept
            })}/>
          <RenderedHtmlContent html={sendingAccept ? submitButtonSendingText : submitButtonText}/>
        </FlaveButton>
      </div>
      {declineMode == "with_button" && <div className="submit-div sub-btn">
        <FlaveButton
          id="btnDecline"
          type={"button"}
          onClick={onSubmitDecline}
          muiColor={"secondary"}
          bootstrapVariant={"btn-danger"}
          disabled={sendingAccept || sendingDecline}
          className={classNames("decline")}
        >
          <i
            className={classNames("submit-icon fa mr-2", {
              "fa-spinner fa-spin": sendingDecline,
              "submit-icon fa fa-times": !sendingDecline
            })}/>
          <RenderedHtmlContent html={sendingDecline ? submitButtonSendingText : declineButtonText}/>
        </FlaveButton>
      </div>}
    </div>
  </div>
}

export default FormButtons;